import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "src/environments/environment";
import {VerifiedDomain} from "../_components/verified-domains/verified-domains.interface";
import {isTool} from "@app/shared/_models/auth";

@Injectable({
  providedIn: 'root'
})
export class VerifiedDomainsService {
  readonly apiUrl = environment.newApiUrl;
  private prefix = `${this.apiUrl}/sender-domains`;
  private http = inject(HttpClient);

  getDomains(
    params?: any
  ) {
    return this.http.get<VerifiedDomain.CollectionResponse>(`${this.prefix}`, {
      ...params && {params}
    });
  }

  getDomainActions(){
    return this.http.get<VerifiedDomain.UnverifiedSenderActionsResponse>(`${this.prefix}/actions`);
  }

  getNotificationEmail(){
    return this.http.get<{ notification_email: string, enabled: boolean }>(`${this.prefix}/notification-email`);
  }

  updateNotificationEmail(
    notification_email: string,
    enabled: boolean
  ){
    return this.http.put<{
      message: string
    }>(`${this.prefix}/notification-email`, {
      enabled,
      notification_email: enabled ? notification_email : null
    }, {
      context: isTool('global')
    });
  }

  updateDomainAction(
    unverified_domain_action: VerifiedDomain.UnverifiedSenderAction
  ){
    return this.http.put<{message: string}>(`${this.prefix}/actions`, {
      unverified_domain_action
    });
  }

  createDomain(domain: string) {
    return this.http.post<VerifiedDomain.Item>(this.prefix, {
      domain
    });
  }

  verifyDomain(domainId: number) {
    return this.http.post<VerifiedDomain.VerificationItem>(`${this.prefix}/${domainId}/verify`, {});
  }

  deleteDomain(domainId: number) {
    return this.http.delete<{message: string}>(`${this.prefix}/${domainId}`);
  }
}
